/* eslint-disable max-lines */
import styled from 'styled-components';

export const WizardLayout = styled.div`
  display: flex;
  gap: 36px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const VerticalStepper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex-shrink: 0;
  width: 200px;
  padding-top: 4px;

  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    overflow-x: auto;
    gap: 0;
  }
`;

export const StepItem = styled.button<{ $active?: boolean; $completed?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  text-align: left;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex: 1;
  }
`;

export const StepIndicator = styled.div<{ $active?: boolean; $completed?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background: ${({ $active, $completed }) => {
    if ($active) return '#1a4d4d';
    if ($completed) return '#1a4d4d';
    return 'transparent';
  }};
  color: ${({ $active, $completed }) => {
    if ($active || $completed) return '#ffffff';
    return '#6b7280';
  }};
  border: 2px solid ${({ $active, $completed }) => {
    if ($active) return '#1a4d4d';
    if ($completed) return '#1a4d4d';
    return '#d1d5db';
  }};
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
`;

export const StepLabel = styled.span<{ $active?: boolean; $completed?: boolean }>`
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active, $completed }) => {
    if ($active) return '#1f2937';
    if ($completed) return '#374151';
    return '#9ca3af';
  }};
  line-height: 1.3;
  transition: color 0.2s ease;
`;

export const StepDescription = styled.span<{ $active?: boolean }>`
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
  margin-top: 2px;
`;

export const StepConnector = styled.div<{ $completed?: boolean }>`
  width: 2px;
  height: 16px;
  margin-left: 15px;
  background: ${({ $completed }) => ($completed ? '#1a4d4d' : '#e5e7eb')};
  transition: background 0.2s ease;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FormArea = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StepTitle = styled.h2`
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 4px;
`;

export const StepSubtitle = styled.p`
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 14px;
  line-height: 1.5;
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const DomainPreview = styled.div`
  display: flex;
  align-items: stretch;
  position: relative;

  &:focus-within {
    & > * {
      border-color: #1a4d4d;
    }
  }
`;

export const DomainPrefix = styled.span`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  padding: 0 8px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-right: none;
  border-radius: 8px 0 0 8px;
  white-space: nowrap;
  user-select: none;
`;

export const DomainSuffix = styled.span`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  padding: 0 10px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-left: none;
  border-radius: 0 8px 8px 0;
  white-space: nowrap;
  user-select: none;
`;

export const DomainInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 42px;
  padding: 8px 6px;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-left: none;
  border-right: none;
  outline: none;
  transition: all 0.15s ease;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const StarsRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const StarButton = styled.button<{ $active?: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  transition: transform 0.1s ease;
  color: ${({ $active }) => ($active ? '#E07B2D' : '#d1d5db')};

  &:hover {
    transform: scale(1.15);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MapWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;

  & > div:last-child {
    border-radius: 12px;
  }
`;

export const CoordinateHint = styled.p`
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.4;
`;

export const LanguageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const LanguageCheckbox = styled.button<{ $selected?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.15s ease;
  text-align: left;
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  border: 1.5px solid ${({ $selected }) => ($selected ? '#1a4d4d' : '#d1d5db')};
  background: ${({ $selected }) => ($selected ? 'rgba(26, 77, 77, 0.05)' : '#ffffff')};
  color: ${({ $selected }) => ($selected ? '#1a4d4d' : '#374151')};

  &:hover:not(:disabled) {
    border-color: ${({ $selected }) => ($selected ? '#1a4d4d' : '#9ca3af')};
  }
`;

export const CheckboxIcon = styled.div<{ $checked?: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid ${({ $checked }) => ($checked ? '#1a4d4d' : '#d1d5db')};
  background: ${({ $checked }) => ($checked ? '#1a4d4d' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s ease;
  color: #ffffff;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const LanguageName = styled.span`
  flex: 1;
  min-width: 0;
`;

export const LanguageCount = styled.span`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
`;

export const TermsScrollBox = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 13px;
  line-height: 1.7;
  color: #374151;

  h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 16px 0 8px;
    color: #1f2937;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    margin: 0 0 10px;
  }
`;

export const TermsCheckboxRow = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-size: 13px;
  font-weight: 500;
  color: ${({ $disabled }) => ($disabled ? '#9ca3af' : '#374151')};
  user-select: none;
`;

export const TermsScrollHint = styled.p`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
  line-height: 1.4;
  font-style: italic;
`;

export const PostalCodeInput = styled.input`
  width: 100%;
  max-width: 200px;
  height: 42px;
  padding: 8px 12px;
  font-size: 15px;
  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;
  letter-spacing: 2px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #1f2937;
  transition: all 0.15s ease;

  &:focus {
    outline: none;
    border-color: #1a4d4d;
  }

  &:hover {
    border-color: #9ca3af;
  }

  &::placeholder {
    color: #d1d5db;
    letter-spacing: 2px;
  }
`;

export const PostalCodeHint = styled.span`
  display: block;
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  align-items: stretch;
  position: relative;

  &:focus-within > button,
  &:focus-within > input {
    border-color: #1a4d4d;
  }
`;

export const PhonePrefixButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  border-radius: 8px 0 0 8px;
  border: 1px solid #d1d5db;
  border-right: none;
  background: #f3f4f6;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e5e7eb;
  }

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: #9ca3af;
  }
`;

export const PhonePrefixDropdown = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 220px;
  max-height: 260px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 50;
  padding: 4px;
  list-style: none;
  margin: 0;
`;

export const PhonePrefixItem = styled.li<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.1s ease;
  color: #1f2937;
  background: ${({ $active }) => ($active ? 'rgba(26, 77, 77, 0.05)' : 'transparent')};

  &:hover {
    background: #f3f4f6;
  }

  span:last-child {
    color: #9ca3af;
    margin-left: auto;
    font-size: 12px;
  }
`;

export const PhoneInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 42px;
  padding: 8px 12px;
  font-size: 15px;
  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;
  letter-spacing: 1px;
  border-radius: 0 8px 8px 0;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #1f2937;
  transition: all 0.15s ease;

  &:focus {
    outline: none;
    border-color: #1a4d4d;
  }

  &:hover {
    border-color: #9ca3af;
  }

  &::placeholder {
    color: #d1d5db;
    letter-spacing: 1px;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
`;

export const NavigationButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const NavButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;

  ${({ $variant }) => {
    if ($variant === 'primary') {
      return `
        background: #1a4d4d;
        color: #ffffff;
        &:hover:not(:disabled) {
          background: #0f3333;
        }
      `;
    }
    return `
      background: transparent;
      color: #6b7280;
      &:hover:not(:disabled) {
        color: #374151;
      }
    `;
  }}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const StatusOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 500px;
  gap: 20px;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const StatusIcon = styled.div<{ $variant: 'pending' | 'success' }>`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $variant }) => $variant === 'pending' && `
    background: rgba(26, 77, 77, 0.1);
  `}

  ${({ $variant }) => $variant === 'success' && `
    background: #d1fae5;
  `}

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const StatusTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin: 0;
`;

export const StatusDescription = styled.p`
  font-size: 15px;
  color: #6b7280;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
`;

export const StatusButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  border-radius: 10px;
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s ease;
  background: #1a4d4d;
  color: #ffffff;

  &:hover {
    background: #15403f;
    transform: translateY(-1px);
  }
`;

export const PendingDots = styled.span`
  display: inline-flex;
  gap: 4px;
  margin-top: 4px;

  span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #1a4d4d;
    animation: bounce 1.4s ease-in-out infinite;

    &:nth-child(1) { animation-delay: 0s; }
    &:nth-child(2) { animation-delay: 0.2s; }
    &:nth-child(3) { animation-delay: 0.4s; }
  }

  @keyframes bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40% { transform: scale(1); opacity: 1; }
  }
`;
